module.exports = __webpack_public_path__ + "static/media/logo.e2aabc94.png";